export const AUSENCIA_DECLARACAO = [
  {
    "tipoDeclaracao": "GFIP",
    "tipoPaExercicio": "Mensal",
    "periodoApuracaoOmissao": [
      "201912"
    ],
    "inscricaoGdf": null,
    "tipoObrigatoriedadeOmissao": null,
    "motivoOmissao": null,
    "tpCnpjCei": "CNPJ",
    "nuCnpjCei": "03763656000154",
    "inCnpjCei": "1",
    "ni": null,
    "codigoImovel": null,
    "codigoImovelVinculado": null
  },
  {
    "tipoDeclaracao": "GFIP",
    "tipoPaExercicio": "Mensal",
    "periodoApuracaoOmissao": [
      "202001",
      "202002",
      "202003",
      "202004",
      "202005",
      "202006",
      "202007",
      "202008",
      "202009",
      "202010",
      "202011",
      "202012",
      "202013"
    ],
    "inscricaoGdf": null,
    "tipoObrigatoriedadeOmissao": null,
    "motivoOmissao": null,
    "tpCnpjCei": "CNPJ",
    "nuCnpjCei": "03763656000154",
    "inCnpjCei": "1",
    "ni": null,
    "codigoImovel": null,
    "codigoImovelVinculado": null
  },
  {
    "tipoDeclaracao": "GFIP",
    "tipoPaExercicio": "Mensal",
    "periodoApuracaoOmissao": [
      "202101",
      "202102",
      "202103",
      "202104",
      "202105",
      "202106",
      "202107",
      "202108",
      "202109",
      "202110",
      "202111",
      "202112",
      "202113"
    ],
    "inscricaoGdf": null,
    "tipoObrigatoriedadeOmissao": null,
    "motivoOmissao": null,
    "tpCnpjCei": "CNPJ",
    "nuCnpjCei": "03763656000154",
    "inCnpjCei": "1",
    "ni": null,
    "codigoImovel": null,
    "codigoImovelVinculado": null
  },
  {
    "tipoDeclaracao": "GFIP",
    "tipoPaExercicio": "Mensal",
    "periodoApuracaoOmissao": [
      "202201",
      "202202",
      "202203",
      "202204",
      "202205",
      "202206",
      "202207",
      "202208",
      "202209"
    ],
    "inscricaoGdf": null,
    "tipoObrigatoriedadeOmissao": null,
    "motivoOmissao": null,
    "tpCnpjCei": "CNPJ",
    "nuCnpjCei": "03763656000154",
    "inCnpjCei": "1",
    "ni": null,
    "codigoImovel": null,
    "codigoImovelVinculado": null
  }
];
